/* ============================================================
   SCOTROW — interaction layer (design-accurate, placeholder data)
   ============================================================ */
(function () {
  'use strict';

  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ---------- Theme toggle (persisted) ---------- */
  function initTheme() {
    const saved = localStorage.getItem('scotrow-theme');
    if (saved === 'light') document.body.classList.add('theme-light');
    $$('[data-theme-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        document.body.classList.toggle('theme-light');
        const light = document.body.classList.contains('theme-light');
        localStorage.setItem('scotrow-theme', light ? 'light' : 'dark');
        syncThemeIcons();
      });
    });
    syncThemeIcons();
  }
  function syncThemeIcons() {
    const light = document.body.classList.contains('theme-light');
    $$('[data-theme-toggle] i').forEach((i) => {
      i.className = light ? 'fa-solid fa-sun' : 'fa-solid fa-moon';
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    const drawer = $('#mobileDrawer');
    if (!drawer) return;
    $$('[data-drawer-open]').forEach((b) =>
      b.addEventListener('click', () => {
        drawer.classList.add('open');
        document.body.style.overflow = 'hidden';
      })
    );
    $$('[data-drawer-close]', drawer).forEach((b) =>
      b.addEventListener('click', () => {
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      })
    );
    $$('.mobile-nav a', drawer).forEach((a) =>
      a.addEventListener('click', () => {
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      })
    );
  }

  /* ---------- Search overlay ---------- */
  function initSearch() {
    const overlay = $('#searchOverlay');
    if (!overlay) return;
    const input = $('#searchInput', overlay);
    const open = () => {
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (input) setTimeout(() => input.focus(), 60);
    };
    const close = () => {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    $$('[data-search-open]').forEach((b) => b.addEventListener('click', open));
    $$('[data-search-close]', overlay).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('open')) close();
    });
  }

  /* ---------- Carousels ---------- */
  function initCarousels() {
    $$('[data-carousel]').forEach((car) => {
      const track = $('.carousel-track', car);
      if (!track) return;
      const step = () => track.firstElementChild
        ? track.firstElementChild.getBoundingClientRect().width + 18
        : 280;
      const prev = $('.carousel-arrow.prev', car);
      const next = $('.carousel-arrow.next', car);
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    });
  }

  /* ---------- FAQ accordion ---------- */
  function initFaq() {
    $$('.faq-item .faq-q').forEach((q) => {
      q.addEventListener('click', () => {
        const item = q.closest('.faq-item');
        const open = item.classList.contains('open');
        $$('.faq-item.open').forEach((i) => i.classList.remove('open'));
        if (!open) item.classList.add('open');
      });
    });
  }

  /* ---------- Vibe tags ---------- */
  function initVibe() {
    $$('.vibe-tags').forEach((group) => {
      $$('.vibe-tag', group).forEach((t) =>
        t.addEventListener('click', () => {
          $$('.vibe-tag', group).forEach((x) => x.classList.remove('active'));
          t.classList.add('active');
        })
      );
    });
  }

  /* ---------- Waveform (visual only) ---------- */
  function buildWaveforms() {
    $$('.waveform[data-wave]').forEach((wf) => {
      if (wf.childElementCount) return;
      const n = 56;
      const played = Math.round(n * 0.32);
      for (let i = 0; i < n; i++) {
        const b = document.createElement('span');
        b.className = 'bar' + (i < played ? ' on' : '');
        // deterministic-ish varied height
        const h = 20 + Math.abs(Math.sin(i * 1.7)) * 80;
        b.style.height = h + '%';
        wf.appendChild(b);
      }
      wf.addEventListener('click', (e) => {
        const rect = wf.getBoundingClientRect();
        const ratio = (e.clientX - rect.left) / rect.width;
        $$('.bar', wf).forEach((bar, i) => bar.classList.toggle('on', i < n * ratio));
      });
    });
  }

  /* ---------- Equalizer bars (AI radio) ---------- */
  function buildEq() {
    $$('.eq[data-eq]').forEach((eq) => {
      if (eq.childElementCount) return;
      for (let i = 0; i < 18; i++) {
        const s = document.createElement('span');
        s.style.animationDelay = (i * 0.07) + 's';
        s.style.height = (30 + (i % 5) * 14) + '%';
        eq.appendChild(s);
      }
    });
  }

  /* ---------- Play buttons -> reveal sticky bottom player ---------- */
  function initPlay() {
    const bottom = $('#bottomPlayer');
    $$('[data-play]').forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (bottom) bottom.classList.add('show');
        const title = btn.getAttribute('data-play-title');
        const artist = btn.getAttribute('data-play-artist');
        const art = btn.getAttribute('data-play-art');
        if (bottom) {
          if (title) { const t = $('.player-meta .t', bottom); if (t) t.textContent = title; }
          if (artist) { const a = $('.player-meta .a', bottom); if (a) a.textContent = artist; }
          if (art) { const im = $('.player-art', bottom); if (im) im.src = art; }
        }
        document.body.style.paddingBottom = '88px';
      })
    );
    // play/pause toggle visual
    $$('.player-play').forEach((p) =>
      p.addEventListener('click', () => {
        const i = $('i', p);
        if (i) i.classList.toggle('fa-play'), i.classList.toggle('fa-pause');
      })
    );
  }

  /* ---------- Like buttons ---------- */
  function initLikes() {
    $$('[data-like]').forEach((b) =>
      b.addEventListener('click', (e) => {
        e.preventDefault();
        b.classList.toggle('liked');
        const i = $('i', b);
        if (i) { i.classList.toggle('fa-regular'); i.classList.toggle('fa-solid'); }
        b.style.color = b.classList.contains('liked') ? 'var(--pink)' : '';
      })
    );
  }

  /* ---------- Stub forms (Klaviyo wiring later) ---------- */
  function initForms() {
    $$('form[data-stub]').forEach((f) =>
      f.addEventListener('submit', (e) => {
        e.preventDefault();
        const btn = $('button[type=submit], .btn', f);
        if (btn) {
          const old = btn.innerHTML;
          btn.innerHTML = '<i class="fa-solid fa-check"></i> You\'re in!';
          btn.disabled = true;
          setTimeout(() => { btn.innerHTML = old; btn.disabled = false; f.reset(); }, 2600);
        }
      })
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    initTheme();
    initDrawer();
    initSearch();
    initCarousels();
    initFaq();
    initVibe();
    buildWaveforms();
    buildEq();
    initPlay();
    initLikes();
    initForms();
  });
})();
